
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/platnosc/blik/potwierdz",
      function () {
        return require("private-next-pages/moje-konto/platnosc/blik/potwierdz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/platnosc/blik/potwierdz"])
      });
    }
  